export default {
  buttons: {
    send_code: 'Anmeldecode senden',
  },
  placeholders: {
    mobile_number: 'Handynummer',
    email: 'E-Mail-Adresse',
  },
  feedback: {
    phone_number_required: 'Bitte gib deine Telefonnummer ein',
    email_required: 'Bitte gib deine E-Mail-Adresse ein',
  },
};
